﻿import LandingPage from "./LandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import HoldingsAndTrades from "./HoldingsAndTrades.svelte";
import DocumentUpload from "./DocumentUpload.svelte";

const confirmationPages = [
	{
		component: LandingPage,
		routeId: "/Registration",
		confirmationHeading: null
	},
	{
		component: PersonalDetails,
		routeId: "/Registration/PersonalDetails",
		confirmationHeading: "Your details"
	},
	{
		component: HoldingsAndTrades,
		routeId: "/Registration/HoldingsAndTrades",
		confirmationHeading: "Holdings and Trades"
	},
	{
		component: DocumentUpload,
		routeId: "/Registration/DocumentUpload",
		confirmationHeading: "Document Upload"
	}
];

export default confirmationPages;
